import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';

export default function Receipts(props) {
  const { receipt, key } = props;

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-label="Expand" id={key}>
        <Typography>{receipt.vendor}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <CardMedia
          component="img"
          style={{ height: 'auto', maxWidth: '100%' }}
          image={receipt.imageURL}
          title="Receipt"
        />
      </AccordionDetails>
    </Accordion>
  );
}
